import { Card, Button } from "antd";
import { ceoAvatar } from "../../../assets";
import { LinkedinOutlined } from "@ant-design/icons";

const { Meta } = Card;
const MemberCard = ({
  title,
  designation,
  profileImg = "",
  flipDelay,
  linkedInUrl,
}) => {
  return (
    <div
      data-aos="flip-right"
      data-aos-duration="700"
      data-aos-delay={flipDelay}
    >
      <Card
        actions={[
          <Button
            type="link"
            icon={<LinkedinOutlined />}
            href={linkedInUrl}
            target="_blank"
            size="large"
            style={{ color: "#635AD9", fontSize: "20px" }}
          />,
        ]}
        className="member-card"
        hoverable
      >
        <div className="member-card-img">
          <img
            src={profileImg}
            className="p-img"
            style={{ borderRadius: "50%" }}
          />
        </div>
        <div className="member-card-name" style={{ marginTop: "28px" }}>
          {title}
        </div>
        <div className="member-card-designation t">{designation} </div>
      </Card>
    </div>
  );
};
export default MemberCard;
